import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode:'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import("./views/Home")
        },
        {
            path: '/artists/:artistName',
            name: 'artist',
            component: () => import('./views/Artist')
        },
        {
            path: '/music/:artistName',
            name: 'music',
            component: () => import('./views/Music')
        },
        {
            path: '/videos/:artistName',
            name: 'videos',
            component: () => import('./views/Videos')
        },
        {
            path: '/live',
            name: 'live',
            component: () => import('./views/Live')
        } ,
        {
            path: '/live/:id',
            name: 'liveReport',
            component: () => import('./views/LiveReport')
        },
        {
            path: '/news',
            name: 'news',
            component: () => import('./views/News')
        },
        {
            path: '/news/:id',
            name: 'article',
            component: () => import('./views/Article')
        },
        {
            path: '/contact',
            name: 'aboutus',
            component: () => import('./views/AboutUs')
        }
    ]
})